// extracted by mini-css-extract-plugin
module.exports = {"active-reserves":"MobileActiveReserveStatus_active-reserves__qCQVr"};